import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Box, Typography } from '@mui/material';

function getWiringCookies() {
  const entries = {};
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    const eqIdx = trimmed.indexOf('=');
    if (eqIdx === -1) continue;
    const name = trimmed.substring(0, eqIdx);
    if (name.startsWith('wiring_')) {
      entries[name] = trimmed.substring(eqIdx + 1);
    }
  }
  return entries;
}

function clearAllWiringCookies() {
  const cookies = getWiringCookies();
  for (const name of Object.keys(cookies)) {
    document.cookie = `${name}=; domain=.actual.video; path=/; max-age=0`;
    document.cookie = `${name}=; path=/; max-age=0`;
  }
}

export default function WiringBanner() {
  const { t } = useTranslation('zoom');
  const [wiringEntries, setWiringEntries] = useState(() => getWiringCookies());

  useEffect(() => {
    setWiringEntries(getWiringCookies());
  }, []);

  const keys = Object.keys(wiringEntries);
  if (keys.length === 0) return null;

  // Derive backend from the hostname → cookie mapping (mirrors nginx map)
  const hostPrefix = window.location.hostname.split('.')[0];
  const backend = wiringEntries[`wiring_${hostPrefix}_url`] || null;

  const handleClear = () => {
    clearAllWiringCookies();
    window.location.reload();
  };

  return (
    <Alert
      severity="info"
      sx={{ mb: 1 }}
      action={
        <Button color="inherit" size="small" onClick={handleClear}>
          {t('wiringBanner.clear')}
        </Button>
      }
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t('wiringBanner.active')} — {window.location.origin}{backend ? ` → ${backend}` : ''}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2, pt: 0.5 }}>
        {keys.sort().map((name) => (
          <li key={name}>
            <Typography variant="caption" sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>
              {name} = {wiringEntries[name]}
            </Typography>
          </li>
        ))}
      </Box>
    </Alert>
  );
}
